module.exports = __webpack_public_path__ + "static/img/17063B_1_2_C_20220428_LC.371b717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17063B_1_2_C_20220428_LC.png
// module id = Gost
// module chunks = 0